export default __webpack_public_path__ + "static/media/star-filled.649506f3.svg";